<template lang="html">
<div>
    <div class="c-inner">
          <div class="song-block">
               <div class="imgs">
                   <img :src="songDat.coverImage" alt="">
               </div>
               <div class="song-name">
                   <span>{{songDat.firstTitle}}</span>
                   <!-- <span>{{infos | getClassName}}</span> -->
<!--                   <span>{{songDat.side}}{{songDat.code}}</span>-->
                   <span>{{songDat.side}}</span>
               </div>
               <div class="ename">{{songDat.foreignTitle}}</div>
          </div>

          <div class="play-area">
               <div class="play-line">
                      <div class="now-time">{{localCurrent}}</div>
                      <div ref="preLine" class="per-line" @click="tapSeek($event)">
                           <div class="per-inner">
                                <div class="back-line">
                                    <div :style="'width:' + buffered" class="store-line"></div>
                                    <div :style="'width:' + localPre" class="up-line">
                                         <div @touchstart="preMove($event,'start')" @touchmove="preMove($event,'move')" @touchend="preMove($event,'stop')" class="play-ball">
                                              <div class="touchPt"></div>
                                         </div>
                                    </div>
                                </div>
                           </div>
                           <!-- <van-slider active-color="#af2d2d" v-model="playper" @change="onChange">
                               <div slot="button" class="play-ball">
                                    <div class="buffered"></div>
                               </div>
                           </van-slider> -->
                      </div>
                      <div class="hole-time">{{songDat.longTime}}</div>
               </div>
               <div class="play-btns">
                      <div class="iconGp" @click="playChange('prev')">
                           <img :src="prevIcon" alt="">
                      </div>
                      <div class="iconGp">
                           <van-icon @click="onChange('pause')" v-if="state=='playing'" class="icon" class-prefix="iconfont" name="pause" />
                           <van-icon @click="onChange('play')" v-else class="icon" class-prefix="iconfont" name="play" />
                      </div>
                      <div class="iconGp" @click="playChange('next')">
                           <img :src="nextIcon" alt="">
                      </div>
               </div>
          </div>
    </div>
</div>
</template>

<script>
import { mapState,mapActions } from 'vuex';
import { timeFormate } from "@/utils/utils";
import vEmits from "@/utils/vEmits";

// import Toast from '@/components/Toast'

import { getPlayData } from "@/api/song";

import Iocn1 from "@/assets/prev.png";
import Iocn2 from "@/assets/next.png";

import { login } from "@/api/login";
import storage from 'good-storage';

export default {
       props:['songDat','account','pwd'],
       components:{
           // Toast
       },
       computed:{
           ...mapState('player',{
                state:'state',
                currentTime:'currentTime',
                duration:'duration',
                dTime:'dTime',
                buffered:'buffered',
                volume:'volume',
                audio:'audio',
                localPre(state){
                    return this.playPause ? this.seekPgress*100 + '%' : state.perPlay;
                },
                localCurrent(state){
                    if(this.playPause){
                        return this.seekTime;
                    }else{
                        return state.currentTime;
                    }
                }
           }),
           // infos : function () {
           //      if(this.songDat.info){
           //           return JSON.parse(this.songDat.info);
           //      }
           // }
       },
       filters:{
           getClassName:function(e){
              if(e){
                  let classArr = e['音乐分类'].split(',');
                  return classArr[classArr.length - 1];
              }
           }
       },
       data(){
           return{
               prevIcon:Iocn1,
               nextIcon:Iocn2,
               playper:30,
               playState:'play',
               playPause:false,
               touchparms:[{
                   el:null,
                   state:'',
                   starx:0,
                   x:0,
                   y:0
               }],
               seekPgress:0,
               seekTime:'',
               organizations:''
           }
       },
       methods:{
           ...mapActions('user',[
               'AuserSet'
           ]),
            ...mapActions('player',[
                'playStateSet',
                'songSet'
            ]),

            storeDispatch:function(e){
                 this.playStateSet({
                     key:e.key,
                     val:e.val
                 });
            },
           storeDispatchuser:function(e){
               this.AuserSet(e);
           },

            onChange:function(state){
                const that = this;
                if(state == 'play'){
                    window.console.log(that.songDat.audition)
                   if(that.songDat.audition=='1'||that.songDat.audition==1||that.$store.state.user.token){
                     //  this.audio[0].play();
                       let promises = that.audio[0].play();
                       if(promises){
                           promises.then(_ => {
                               window.console.log(_);
                           }).catch(error => {
                               // Autoplay was prevented.
                               // Show a "Play" button so that user can start playback.
                               window.console.log(error.message);
                           });
                       }
                   }else{
                        vEmits.$emit('showModel','播放资源需要登录，是否前往登录？');
                   }
                }else{
                   this.audio[0].pause();
                }
            },

            playSeek:function(){
                this.storeDispatch({
                   key:'currentTime',
                   val:timeFormate(this.dTime*this.seekPgress,1)
                });

                this.storeDispatch({
                   key:'perPlay',
                   val:this.seekPgress*100 + '%'
                });

                this.audio[0].currentTime = this.dTime*this.seekPgress;
            },

            preMove:function(e,state){
                let eDat = e.targetTouches;
                let vues = this;
                if(eDat.length == 1){
                    if(state == 'start'){
                        vues.touchparms.state = 'start';
                    }else if(state == 'move'){
                         vues.touchparms.state = 'move';
                         let preLine = vues.$refs.preLine;
                         let seekPgress = ((eDat[0].clientX - preLine.offsetLeft)/preLine.clientWidth + '').substr(0,4);
                         if(seekPgress <= 1){
                             vues.playPause = true;
                             vues.seekPgress = seekPgress;
                             vues.seekTime = timeFormate(vues.dTime*seekPgress,1);
                         }
                    }
                }else if(state == 'stop'){
                    vues.playSeek();
                    vues.playPause = false;
                }
            },

            tapSeek:function(e){
                let preLine = this.$refs.preLine;
                let seekPgress = ((e.clientX - preLine.offsetLeft)/preLine.clientWidth + '').substr(0,4);
                if(seekPgress <= 1){
                    this.seekPgress = seekPgress;
                    this.seekTime = timeFormate(this.dTime*seekPgress,1);
                    this.playSeek();
                }
            },

            playChange:function(type){
               window.console.log(type)
                this.$emit('playChange',type);
            },

            rePlay:function(){
                 this.seekPgress = 0;
                 this.playSeek();
            },

           getUrls:function (name){
               var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
               var r = window.location.search.substr(1).match(reg);
               if(r != null) {
                   return unescape(r[2]);
               }
               return null;
           },

       },
       mounted:function(){

           //如果地址栏里有用户名和密码存到storge里
           if(this.getUrls('account')!==null&&this.getUrls('pwd')!==null){
               storage.set('userName',this.getUrls('account'));
               storage.set('pwd',this.getUrls('pwd'));
           }

           let vues = this;
           let querys = this.$route.query;

           if((storage.get("userName")!==undefined&&storage.get("pwd")!==undefined)&&(storage.get("userName")!==''&&storage.get("pwd")!=='')){

           // if((vues.account!==undefined&&vues.pwd!==undefined)&&(vues.account!==''&&vues.pwd!=='')){
               login({
                   account:storage.get("userName"),
                   pwd:storage.get("pwd")
               }).then(res => {
                   storage.set('userInfo',{
                       token:res.token,
                       userId:res.id
                   });
                   vues.storeDispatchuser(res);
                   getPlayData({
                       materialId:querys.icd,
                       timbre:2,
                       userId:res.id
                   }).then(res => {
                       if(res.url && !querys.unSet){
                           let urlArrs = res.url.split('/');
                           vEmits.$emit('setMedia', {
                               data:{
                                   decryptdata:{
                                       id:urlArrs[urlArrs.length - 1],
                                       token:vues.$store.state.user.token
                                   }
                               },
                               urls:res.url,
                               songDat:{
                                   iab:querys.iab,
                                   icd:querys.icd,
                                   songName:vues.songDat.firstTitle,
                                   songImg:vues.songDat.coverImage
                               }
                           })
                       }
                   });
               }).catch(errs => {
                   vEmits.$emit('show',errs);
               })
           }else{
               getPlayData({
                   materialId:querys.icd,
                   timbre:2,
                   userId:vues.$store.state.user.userId
                   // userId:storage.get("userInfo").userId
               }).then(res => {
                   if(res.url && !querys.unSet){
                       let urlArrs = res.url.split('/');
                       vEmits.$emit('setMedia', {
                           data:{
                               decryptdata:{
                                   id:urlArrs[urlArrs.length - 1],
                                   token:vues.$store.state.user.token
                               }
                           },
                           urls:res.url,
                           songDat:{
                               iab:querys.iab,
                               icd:querys.icd,
                               songName:vues.songDat.firstTitle,
                               songImg:vues.songDat.coverImage
                           }
                       })
                   }
               });
           }
       }
}
</script>

<style lang="css" scoped>

.song-block .imgs{
    width: 140px;
    height: 140px;
    background: #efefef;
    border-radius: 3px;
    margin: 0 auto;
}

.song-block .imgs img{
    width: 140px;
    height: 140px;
}

.song-name{
    margin-top: 12px;
    line-height: 21px;
    text-align: center;
}

.song-name span{
    font-size: 14px;
    letter-spacing: 0.72px;
    margin: 0px 2px;
}

.ename{
    font-size: 14px;
    margin: 0 24px;
    text-align: center;
    line-height: 21px;
}

/* 播放 */

.play-area{
    background: white;
    padding-bottom: 30px;
    padding-top: 12px;
}

.play-line{
    display: flex;
    height: 45px;
    align-items: center;
}

.now-time,
.hole-time{
    width: 60px;
    flex-shrink: 0;
    text-align: center;
    color: #666666;
}

.per-line{
    width: 255px;
    height: 24px;
    display: flex;
    align-items: center;
}

.back-line{
    height: 2px;
    width: 249px;
    margin-left: 3px;
    position: relative;
    background: #e5e5e5;
}

.store-line{
  position: absolute;
  left: 0px;
  top: 0px;
  height: 2px;
  background: #999999;
  z-index: 1;
}

.up-line{
    position: absolute;
    left: 0px;
    top: 0px;
    height: 2px;
    background: #af2d2d;
    z-index: 2;

    transition-property: all;
    transition-duration: 0s;
}

.play-ball{
    width: 12px;
    height: 12px;
    background: #af2d2d;
    border-radius: 12px;
    box-shadow: 0px 2px 3px #999999;
    position: absolute;
    right: -6px;
    top: -5.5px;
}

.play-ball .touchPt{
    height: 30px;
    width: 30px;
    margin-left: -9px;
    margin-top: -9px;
}

.play-btns{
    display: flex;
    align-items: center;
    /* justify-content: space-evenly; */
    width: 80%;
    margin-left: 10%;
    justify-content: space-around;
}

.play-btns .iconGp:nth-child(2) .icon{
    font-size: 60px;
    color: #af2d2d;
}

.play-btns .iconGp img{
    height: 30px;
}

.buffered{
    height: 20px;
    background: salmon;
    position: absolute;
    left: 0px;
}

</style>
